module.exports = __webpack_public_path__ + "static/media/ill_barn_eksem.55459709.svg";